import { createSlice } from "@reduxjs/toolkit";
import api from "../../api/whiteboards/resource";
import i18n from 'i18next';

export const fetchWhiteboard = (params) => async (dispatch) => {
    dispatch(setStatus("loading"));
    dispatch(setCustomMessage(""));
    
    try {
        const response = await api.index({
            ...params
        });
        dispatch(setWhiteboards(response.data));
        dispatch(setMeta(response.meta));
        dispatch(setStatus("success"));
    } catch (e) {
        dispatch(setStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
    }
};

export const addWhiteboard = (params) => async (dispatch) => {
    dispatch(setCurrentAction("create"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        await api.store({
            ...params
        });
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        if (e.response.status === 409)
            dispatch(setCustomMessage(i18n.t(`toast.duplicateBoard`)));
            // dispatch(setWhiteboardStatus("failed"));
    } finally {
        // dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

export const updateWhiteboard = (id, params) => async (dispatch) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        await api.update(id, params);
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        if (e.response.status === 409)
            dispatch(setCustomMessage(i18n.t(`toast.duplicateBoard`)));
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

export const lockWhiteboard = (ids, isLock) => async (dispatch) => {
    dispatch(setCurrentAction("update"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        const response = await api.lock(ids, isLock);
        if (response.message === "locked" || response.message === "unlocked" || response.message === "lockedAll" || response.message === "unlockedAll") {
            dispatch(setCustomMessage(i18n.t(`toast.${response.message}`)));
        }
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

export const moveToTrashMultiple = (ids) => async (dispatch) => {
    dispatch(setCurrentAction("trash"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        const response = await api.moveToTrashMultiple(ids);
        if (response.message === "removed" || response.message === "removedAll") {
            dispatch(setCustomMessage(i18n.t(`toast.${response.message}`)));
        }
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

//chungnm2

//copy White Board
export const copyWB = (need_return_data, name, id) => async (dispatch) => {
    dispatch(setCurrentAction("copy"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        await api.copy(need_return_data, name, id);
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        if (e.response.status === 409)
            dispatch(setCustomMessage(i18n.t(`toast.duplicateBoard`)));
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

//change name White Board
export const changeNameWB = (id, name) => async (dispatch) => {
    dispatch(setCurrentAction("changeName"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        await api.changeName(id, name);
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        if (e.response.status === 409)
            dispatch(setCustomMessage(i18n.t(`toast.duplicateBoard`)));
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

//delete forever White Board
export const deleteForever = (id) => async (dispatch) => {
    dispatch(setCurrentAction("deleteForever"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        const response = await api.delete(id);
        if (response.message === "edited") {
            dispatch(setCustomMessage(i18n.t(`toast.${response.message}`)));
        }
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};
//delete forever White Board
export const deleteForeverMultiple = (ids) => async (dispatch) => {
    dispatch(setCurrentAction("deleteForever"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        const response = await api.deleteMultiple(ids);
        if (response.message === "edited") {
            dispatch(setCustomMessage(i18n.t(`toast.${response.message}`)));
        }
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};
//delete forever White Board
export const deleteForeverAll = () => async (dispatch) => {
    dispatch(setCurrentAction("deleteForever"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        await api.deleteAll();
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};
//end chungnm2

export const restoreFromTrashMultiple = (ids) => async (dispatch) => {
    dispatch(setCurrentAction("restore"));
    dispatch(setWhiteboardStatus("loading"));
    dispatch(setCustomMessage(""));
    try {
        const response = await api.restoreFromTrashMultiple(ids);
        if (response.message === "restored" || response.message === "restoredAll") {
            dispatch(setCustomMessage(i18n.t(`toast.${response.message}`)));
        }
        dispatch(setWhiteboardStatus("success"));
    } catch (e) {
        dispatch(setWhiteboardStatus("failed"));
    } finally {
        dispatch(setCurrentAction(""));
        dispatch(setStatus("waiting"));
        dispatch(setWhiteboardStatus("waiting"));
    }
};

const initialState = {
    status: "waiting",
    customMessage: "",
    whiteboardStatus: "waiting",
    currentAction: '',
    whiteboards: [],
    meta: {
        total: null,
        per_page: null,
        last_page: null,
        page: null,
        filter: {
            name: null,
            startDate: null,
            endDate: null,
            myBoard: null,
            sharedBoard: null,
            isMovedToTrash: null
        },
        data: [],
    },
};

const whiteboardList = createSlice({
    name: "whiteboardList",
    initialState,
    reducers: {
        setWhiteboards: (state, action) => {
            state.whiteboards = action.payload;
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setCustomMessage: (state, action) => {
            state.customMessage = action.payload;
        },
        setWhiteboardStatus: (state, action) => {
            state.whiteboardStatus = action.payload;
        },
        setCurrentAction: (state, action) => {
            state.currentAction = action.payload;
        },
        setMeta: (state, action) => {
            state.meta = { ...state.meta, ...action.payload };
        }

    },
});

export const {
    setWhiteboards,
    setMeta,
    setStatus,
    setWhiteboardStatus,
    setCurrentAction,
    setCustomMessage
} = whiteboardList.actions;
export default whiteboardList.reducer;